import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Request } from './model/request.model';
import { ResposeGeneric } from '../../../core/shared/respose-generic';
import { environment } from '../../../../environments/environment';
import { UtilityService } from '../../../core/shared/utility.service';
import { FilterRequest } from './model/filter-request.model';
import { DocumentoDeliveryRequest } from './model/documento-delivery-request.model';
import { DenyRequest } from './model/deny-request';
import { FileUpload } from './model/file-upload.model';

@Injectable()
export class RequestService {
  uriFiles = environment.urlServices + 'archivos';
  uriRequest = environment.urlServices + 'solicitudes';
  uriDenyRequest = this.uriRequest + '/rechazos';
  uriReconRequest = this.uriRequest + '/reconocidas';
  uriEvaluatorsRequest = this.uriRequest + '/evaluadores';
  uriStatusRequest = this.uriRequest + '/estados';
  uriDetailRequest = this.uriRequest + '/detalles';
  uriTypesRequestAvaible = this.uriRequest + '/tipos';
  uriTypesDocument =  this.uriRequest + '/documentos';
  uriDocumentsDelivery = this.uriTypesDocument + '/recibidos';
  uriCollege =  this.uriRequest + '/instituciones';
  uriSubjectMatter =  this.uriRequest + '/materias';
  uriTesting =  this.uriRequest + '/pruebas';
  uriRequestTesting = environment.urlServices + 'solicitudesPruebas';
  uriTypeTesting =  this.uriRequest + '/listPruebas';
  uriRequestAssignment =  this.uriRequest + '/asignaciones';
  uriRequestAssignmentLeng = this.uriRequest + '/asignacionesIdiomas';
  uriRequestAssistence =  this.uriRequest + '/asistencial';
  uriRequestAssistenceLeng =  this.uriRequest + '/asistencialIdiomas';

  constructor(private httpClient: HttpClient, private utilityService: UtilityService) { }

  denyRequets(denyRequet: DenyRequest): Observable<ResposeGeneric>  {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return this.httpClient.post<ResposeGeneric>(this.uriDenyRequest, denyRequet, {headers: headers});
  }

  getColleges(): Observable<ResposeGeneric>  {
    return this.httpClient.get<ResposeGeneric>(this.uriCollege);
  }

  getDetailRequets(request, type, evaluador, estado): Observable<ResposeGeneric> {
    const parameters = { solicitud : request , tipo : type, evaluador: evaluador , estado : estado};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriDetailRequest, parameters));
  }

  getDocumentsDelivery(request, type): Observable<ResposeGeneric> {
    const parameters = { solicitud : request , tipo : type};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriDocumentsDelivery, parameters));
  }

  sendDocumentsDelivery(documentoDeliveryRequest: DocumentoDeliveryRequest): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriDocumentsDelivery, documentoDeliveryRequest);
  }

  getEvaluatorRequest(solicitud: number): Observable<ResposeGeneric> {
    const parameters = { solicitud : solicitud };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriEvaluatorsRequest, parameters));
  }


  getFile(cedula: String, file: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula , file : file};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriFiles, parameters));
  }

  getTypeRequestAvailable(cedula: String, programa: String, version: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula , programa : programa, version: version};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriTypesRequestAvaible, parameters));
  }

  getTypesDocument(tipo: String): Observable<ResposeGeneric> {
    const parameters = { tipo : tipo };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriTypesDocument, parameters));
  }

  getReconRequest(solicitud: number): Observable<ResposeGeneric> {
    const parameters = { solicitud : solicitud };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriReconRequest, parameters));
  }
  getStatusRequest(cedula: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriStatusRequest, parameters));
  }

  getSubjectMatter(): Observable<ResposeGeneric>  {
    return this.httpClient.get<ResposeGeneric>(this.uriSubjectMatter);
  }

  savedRequest(request: Request): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriRequest, request);
  }

  getRequest(requestFilter: FilterRequest ): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequest, requestFilter));
  }

  getRequestAssignment(requestFilter: FilterRequest ): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestAssignment, requestFilter));
  }
  getRequestAssignmentLeng(requestFilter: FilterRequest ): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestAssignmentLeng, requestFilter));
  }

  getRequestAssistence(requestFilter: FilterRequest ): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestAssistence, requestFilter));
  }

  getRequestAssistenceLeng(requestFilter: FilterRequest ): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestAssistenceLeng, requestFilter));
  }

  getTestings(): Observable<ResposeGeneric>  {
    return this.httpClient.get<ResposeGeneric>(this.uriTesting);
  }

  savedRequestTesting(request: Request): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriRequestTesting, request);
  }

  getTypeTesting(tipoPrueba: String): Observable<ResposeGeneric>  {
    const parameters = { tipo : tipoPrueba };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriTypeTesting, parameters));
  }

  uploadFile(fileUpload: FileUpload): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriFiles, fileUpload);
  }

}
